/**
 * Config of HighChartDataProvider
 */
var HighChartDataProviderConfig = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param version
     */
    function HighChartDataProviderConfig(version) {
        if (version === void 0) { version = 'v1'; }
        this.API_VERSION = version;
        this.API_PRICES_QUALITY = 'BST';
        this.API_PRICES_TRADING_SCHEDULE_EVENT_LIST = "/api/" + this.API_VERSION + "/prices/tradingSchedule/event/list";
        this.API_PRICES_GET = "/api/" + this.API_VERSION + "/prices/get";
        this.API_PRICES_TSS_INTRADAY_SUBSAMPLE_LIST = "/api/" + this.API_VERSION + "/prices/timeSeries/intraday/subsample/list";
        this.API_PRICES_TSS_EOD_LIST = "/api/" + this.API_VERSION + "/prices/timeSeries/eod/list";
        this.API_PRICES_TSS_EOD_SUBSAMPLE_LIST = "/api/" + this.API_VERSION + "/prices/timeSeries/eod/subsample/list";
        this.INTRADAY_NODATA_RETRIES = 10;
    }
    return HighChartDataProviderConfig;
}());
export { HighChartDataProviderConfig };
//# sourceMappingURL=HighChartDataProviderConfig.js.map